const zIndexPriorities = ['modal', 'popupMenu', 'popupMenuCaret', 'pageHeader'];

const zIndexMap = {} as { [key: string]: number };
let zIndex = 1000;
zIndexPriorities.forEach(key => {
  zIndexMap[key] = zIndex--;
});

export default zIndexMap;